import React, { Component } from 'react';
import Image from 'next/image';
import PriceOptions from '../PriceOptions';
import { Lottie } from '@crello/react-lottie';

class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      show: false,
    };
    this.click = this.click.bind(this);
  }
  click() {
    this.setState({ show: !this.state.show });
  }

  render() {
    return (
      <span className={this.state.show ? 'order-includes' : 'order-includes'}>
        <span
          dangerouslySetInnerHTML={{
            __html: '<span>' + (this.state.show ? this.props.text : this.props.text.split(' ').splice(0, 19).join(' ') + '...') + '</span>',
          }}
          ref="myImgContainer"
        ></span>

        {!this.state.show ? (
          <span onClick={this.click} className="text-purple cursor-pointer underline-anim">
            <span>{this.props.viewMore ? this.props.viewMore : 'view more'}</span>
            <svg viewBox="0 0 13 20">
              <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
            </svg>
          </span>
        ) : (
          <span onClick={this.click} className="text-purple cursor-pointer underline-anim">
            {' '}
            <span> {this.props.viewLess ? this.props.viewLess : 'view less'} </span>
            <svg viewBox="0 0 13 20">
              <polyline points="0.5 19.5 3 19.5 12.5 10 3 0.5" />
            </svg>
          </span>
        )}
      </span>
    );
  }
}

class Package extends Component {
  render() {
    var styles = {};

    var arr = this.props.data.content;
    let elements = [];

    for (let i = 0; i < arr.length; i++) {
      elements.push(
        <li className="text-14 leading-17 mb-10" key={i}>
          <div className="relative flex ptich ml-20">
            {/*<svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>*/}
            {/*    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />*/}
            {/*</svg>*/}
            {arr[i]}
          </div>
        </li>
      );
    }

    if (this.props.data.gift) {
      elements.push(
        <li className="text-purple text-14 ml-20 leading-17 mb-20" key={arr.length}>
          {this.props.data.gift}
        </li>
      );
    }
    return (
      <span className="block mb-23 lg:mb-0 order-includes collapsed" ref="myImgContainer">
        <span className="text-purple block text-16 uppercase font-bold my-10 lg:mt-15">
          {this.props.includeText ? this.props.includeText : 'Order Includes'}
        </span>

        <ul className={'lg:mb-10 ' + ('columns-' + this.props.columns)}>{elements}</ul>
      </span>
    );
  }
}

class Multiservice extends Component {
  constructor(props) {
    super(props);

    this.state = {
      price: '',
      duration: '',
      data: null,
      playLottieAnimation: 'playing',
    };

    this.setPrice = this.setPrice.bind(this);

    this.playVideo = this.playVideo.bind(this);

    this.mouseEnter = this.mouseEnter.bind(this);
  }

  setPrice(price, duration) {
    this.setState({ price: price, duration: duration });
  }
  ref = player => {
    this.player = player;
  };
  playVideo(e) {
    e.target.closest('.player-overlay').style.display = 'none';
    e.target.closest('.player-wrapper').querySelector('video').play();
    // console.log(e);
  }
  mouseEnter(e) {
    if (window.innerWidth > 768) {
      if (e.target.closest('.player-overlay')) {
        //
        // e.target.closest('.player-overlay').style.display = 'none';
        //
        // e.target.closest('.player-wrapper').querySelector('video').muted = false;
      }

      // e.target.closest('.player-wrapper').querySelector('video').play();
    }
  }
  mouseLeave(e) {
    if (window.innerWidth > 768) {
      // e.target.closest('.player-wrapper').querySelector('video').pause();
    }
  }

  getJson = async url => {
    const api_call = await fetch(url);
    const data = await api_call.json();

    this.setState({ data: data });
  };

  render() {
    var preview = '';
    if (this.props.preview.type === 'video') {
      preview = (
        <div
          className="player-wrapper bg-gradient-custom"
          style={{ position: 'relative', paddingBottom: '56.25%', overflow: 'hidden' }}
          onMouseEnter={this.mouseEnter}
          onMouseLeave={this.mouseLeave}
        >
          <div className="player-overlay absolute top-0 left-0 w-full h-full flex items-center justify-center z-10 cursor-pointer">
            {this.state.data && <Lottie config={{ animationData: this.state.data, loop: true }} playingState={this.state.playLottieAnimation} />}
          </div>
        </div>
      );
    } else if (this.props.preview.type === 'image') {
      preview = <Image src={this.props.preview} alt=""></Image>;
    } else if (this.props.preview.type === 'iframe') {
      preview = <iframe title={this.props.title} src={this.props.preview} frameBorder="0" width="100%" height="250"></iframe>;
    }
    return (
      <div className="multiservice py-20 lg:py-30" id={this.props.id}>
        <div className="container">
          <p className="relative bg-green lg:bg-transparent text-white lg:text-black text-16 lg:text-36 leading-none px-20 py-20 font-black uppercase mb-23 lg:mb-0 -mx-20">
            {this.props.title}{' '}
            {this.props.badge ? (
              <span
                className={` absolute text-13 py-2 px-10 rounded-5 font-bold capitalize right-15 top-1/2 translate-50 lg:relative lg:translate-y-0  lg:ml-10 lg:align-middle inline-block ${this.props.badgeText ? 'bg-purple text-white' : 'lg:bg-green-badge lg:text-white border border-blue lg:border-green-badge animate-badge-mobile lg:animate-badge'} `}
              >
                {this.props.badgeText ? this.props.badgeText : 'Bestseller'}
              </span>
            ) : (
              <span className={this.props.icon}></span>
            )}{' '}
          </p>

          <div className="lg:grid lg:grid-cols-12 lg:pb-15">
            <div className="lg:col-span-5 mb-20 lg:mb-23">{preview}</div>
            <div className="lg:col-span-7 lg:pl-23">
              <span className="multiservices-desc lg:text-16">
                {this.props.order ? (
                  <>
                    {<About viewMore={this.props.viewMore} viewLess={this.props.viewLess} click={this.packageClick} text={this.props.about}></About>}
                    <Package
                      includeText={this.props.includeText}
                      columns={this.props.order.columns}
                      click={this.packageClick}
                      data={this.props.order}
                    ></Package>{' '}
                  </>
                ) : (
                  this.props.about
                )}
              </span>
              {this.props.price && (
                <>
                  {typeof this.props.price[this.props.currency] === 'string' ? (
                    <p className="text-16 font-bold uppercase float-left mt-5">
                      {this.props.price_title ? this.props.price_title : 'Starting from'}
                      <span className="line-break-desktop"></span>
                      <span className="text-purple ml-5">
                        {typeof this.props.price[this.props.currency] === 'string' ? this.props.price[this.props.currency] : this.state.price}
                      </span>
                    </p>
                  ) : (
                    <div className="float-left">
                      <PriceOptions
                        currency={this.props.currency}
                        setPrice={this.setPrice}
                        options={this.props.price[this.props.currency]}
                      ></PriceOptions>

                      <p className="text-16 font-bold uppercase mt-5">
                        {this.props.price_title ? this.props.price_title : 'Starting from'}
                        <span className="line-break-desktop"></span>
                        <span className="text-purple ml-5">
                          {typeof this.props.price[this.props.currency] === 'string' ? this.props.price[this.props.currency] : this.state.price}
                        </span>
                      </p>
                    </div>
                  )}
                </>
              )}

              <a
                className="get-offer-button bg-green hover:bg-purple transition-all transition-400 text-white px-23 lg:px-23 py-5 text-16 lg:text-13 float-right rounded-md cursor-pointer"
                onClick={e => this.props.quote.action(this.props.titleNode, this.state.price, this.state.duration)}
              >
                {this.props.quote ? this.props.quote.text : 'Get Offer'}
              </a>

              {this.props.actionButton ? (
                <a
                  rel="noopener noreferrer nofollow"
                  href={this.props.actionButtonLink}
                  target="_blank"
                  className="inline-block w-full lg:w-auto border-2 lg:border-0 border-purple rounded-md text-center py-5 text-purple mb-23 see-example-button lg:bg-purple hover:bg-green transition-all transition-400 lg:text-white lg:inline-block px-23 lg:py-5 lg:float-right mt-23 lg:mt-0 text-16 lg:text-13 "
                >
                  {this.props.actionButtonText}
                </a>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>

        <style jsx>{`
          .multiservice:nth-child(2n) {
            background-color: #fff;
          }
        `}</style>
      </div>
    );
  }

  componentDidMount() {
    this.getJson('https://lottie.host/f2ce8a9e-bdd1-45a2-9755-2bb3053ab36f/nTABNs03g0.json');
  }
}
export default Multiservice;
